import { render, staticRenderFns } from "./timeline-item.vue?vue&type=template&id=f96eb53e&"
import script from "./timeline-item.vue?vue&type=script&lang=js&"
export * from "./timeline-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f96eb53e')) {
      api.createRecord('f96eb53e', component.options)
    } else {
      api.reload('f96eb53e', component.options)
    }
    module.hot.accept("./timeline-item.vue?vue&type=template&id=f96eb53e&", function () {
      api.rerender('f96eb53e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/timeline/timeline-item.vue"
export default component.exports